/*
 * PBK About Hero — MV シームレス変形（全面 → 右ドック）
 * 仕様(CL 2026-07-18): ロゴビジュアルが「全面(1360x600)」から「右カラム(678x380 @x722)」へ
 *   シームレスに変形して移動（2分割表示にしない）。
 * 実装: MV は position:sticky で固定。stage の scroll 進捗 p(0→1) で card の
 *   width/height/translateX を全面→右ドックへ補間。ロゴは card 幅比で uniform scale（歪ませない）。
 *   - width/height は card(absolute) のみ変更 → 周囲レイアウト不変
 *   - Figma 比率: dock は content 幅 W に対し 左0.5015W / 幅0.4985W / 高=幅*0.5605(=380/678)
 *   - scroll 連動（自動再生ではない）→ reduced-motion でも動作。SP(<990) は morph 無効=静的縦積み
 */
(function () {
  'use strict';

  var DOCK_LEFT = 0.5015;      // 722-40 = 682 → 682/1360
  var DOCK_W = 0.4985;         // 678/1360
  var DOCK_H_RATIO = 380 / 678;
  var BASE_H_RATIO = 600 / 1360;
  var STICKY_TOP = 96;         // .pbk-about-hero__mv の sticky top
  var MV_MARGIN = 20;          // .pbk-about-hero__mv margin-top
  var MORPH_PX = 480;          // モーフ完了までの scroll 量
  var GATE_LEAD_PX = 120;      // ステートメント出現ゲートの先出し量（大きいほど早く出現）
  var GATE_DEEP_RATIO = 0.2;   // 保険: ステートメント上端がここまで上がったら座標条件を問わず出す
  var GATE_FAILSAFE_MS = 4000; // 保険: 初回スクロール後この時間で未発火なら無条件で出す

  // MV 動画（ロゴモーション）。loop なし = 1 回再生して終端（ロゴ）で静止。
  // 自動再生の本体は markup の muted + playsinline + autoplay 属性で、play() は保険。
  // reduced-motion では CSS が静止ロゴへ差し替える → src を退避して取得も止め、
  // 右下ボタンを押した時だけ src を戻して再生（自動再生はしない）。
  function setupVideo(stage) {
    var media = stage.querySelector('[data-about-hero-media]');
    var video = stage.querySelector('.pbk-about-hero__video');
    var toggle = stage.querySelector('[data-about-hero-toggle]');
    if (!video) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setState(state) {
      if (!toggle) return;
      toggle.dataset.state = state;
      toggle.setAttribute('aria-label', state === 'playing' ? 'ロゴモーションを一時停止' : 'ロゴモーションを再生');
    }

    // reduced-motion 時の src 退避 / 復帰。<source> は video_tag だと複数ありうる
    function sources() {
      return video.querySelectorAll('source');
    }
    function detachSrc() {
      var list = sources();
      for (var i = 0; i < list.length; i++) {
        if (list[i].getAttribute('src')) {
          list[i].dataset.src = list[i].getAttribute('src');
          list[i].removeAttribute('src');
        }
      }
      if (video.getAttribute('src')) {
        video.dataset.src = video.getAttribute('src');
        video.removeAttribute('src');
      }
      video.load(); // 進行中の取得を打ち切る
    }
    function attachSrc() {
      var restored = false;
      var list = sources();
      for (var i = 0; i < list.length; i++) {
        if (list[i].dataset.src) {
          list[i].setAttribute('src', list[i].dataset.src);
          delete list[i].dataset.src;
          restored = true;
        }
      }
      if (video.dataset.src) {
        video.setAttribute('src', video.dataset.src);
        delete video.dataset.src;
        restored = true;
      }
      if (restored) video.load();
      return restored;
    }

    // 終端まで再生済みなら頭出し。theme dev の proxy は Range 非対応で seek が効かない
    // （seekable=0）ため、currentTime が動かなければ load() で読み直して 0 に戻す
    function rewindIfEnded() {
      var d = video.duration;
      var atEnd = video.ended || (d && isFinite(d) && video.currentTime >= d - 0.05);
      if (!atEnd) return;
      try {
        video.currentTime = 0;
      } catch (e) {}
      if (video.currentTime > 0.1) video.load();
    }

    video.addEventListener('play', function () { setState('playing'); });
    video.addEventListener('pause', function () { setState('paused'); });
    video.addEventListener('ended', function () { setState('paused'); });

    if (toggle) {
      toggle.hidden = false; // JS 無効時は死んだボタンを出さない
      toggle.addEventListener('click', function () {
        if (!video.paused && !video.ended) {
          video.pause();
          return;
        }
        attachSrc();
        if (media) media.classList.add('is-motion');
        rewindIfEnded();
        var resumed = video.play && video.play();
        if (resumed && resumed.catch) resumed.catch(function () {});
      });
    }

    if (reduce) {
      video.pause();
      video.removeAttribute('autoplay');
      detachSrc();
      setState('paused');
      return;
    }

    setState('playing');
    var played = video.play && video.play();
    if (played && played.catch) played.catch(function () {});
  }

  function initStage(stage) {
    if (stage.dataset.aboutHeroInit === '1') return;
    stage.dataset.aboutHeroInit = '1';
    setupVideo(stage);

    // ステートメントのテキスト出現ゲート（data-pbk-tr-manual = IO 監視外・こちらで発火）。
    // カードが右へ移動しテキスト領域と横方向に被らなくなってから reveal（かぶり防止）
    var statement = stage.querySelector('[data-pbk-tr-manual]');
    var stRevealed = false;
    var stTimer = 0;
    var morphDone = false;      // 直近 update() で p=1（モーフ完了）に達したか

    // 実際に出す処理。IO 監視外の要素なので「ここが呼ばれない = 永久に不可視」→
    // 失敗経路を全て塞ぐ（pbk-text-reveal.js 未ロード時も .is-visible を直付けして可視化する）
    function revealStatement() {
      if (stRevealed || !statement) return;
      stRevealed = true;
      if (stTimer) { clearTimeout(stTimer); stTimer = 0; }
      if (window.pbkTextReveal && window.pbkTextReveal.revealWithin) {
        window.pbkTextReveal.revealWithin(statement);
        return;
      }
      var els = statement.querySelectorAll('.pbk-tr');
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-visible');
    }

    function gateStatement() {
      if (stRevealed || !statement) return;
      var st = statement.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var inView = st.top < vh * 0.92 && st.bottom > 0;
      if (!inView) return;
      if (mqDesktop.matches && !morphDone && st.top > vh * GATE_DEEP_RATIO) {
        // PC: カード左端がステートメント右端に近づいた時点で先出し（フェード0.9sの間に
        // カードが通過し終える見込み分だけ手前 = GATE_LEAD_PX）。完全クリア待ちだと出現が遅れて感じるため。
        // ただし「モーフ完了(p=1)」「ステートメントが画面上部まで到達」のいずれかに達したら
        // 座標条件は問わない。ドック位置は幅比例なので、狭幅ではカード左端がテキスト右端 -120px
        // まで届かず旧実装はこの条件が永久に成立せずテキストが不可視のまま残っていた
        if (card.getBoundingClientRect().left < st.right - GATE_LEAD_PX) return;
      }
      // SP はモーフ無効（縦積み・被りなし）→ 画面に入ったら即 reveal
      revealStatement();
    }

    var mv = stage.querySelector('[data-about-hero-mv]');
    var card = stage.querySelector('[data-about-hero-card]');
    var logo = stage.querySelector('.pbk-about-hero__logo');
    // モーフ要素が無いとゲートを開く担当がいなくなる → 演出を諦めて即表示（不可視放置を防ぐ）
    if (!mv || !card) { revealStatement(); return; }

    var mqDesktop = window.matchMedia('(min-width: 990px)');
    var ticking = false;
    // reduced-motion は CSS 側で .pbk-tr が最初から最終表示 → ゲート待ちにする意味が無い
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealStatement();
    }

    function reset() {
      card.style.width = '';
      card.style.height = '';
      card.style.transform = '';
      if (logo) logo.style.transform = '';
    }

    function update() {
      ticking = false;
      if (!mqDesktop.matches) { reset(); gateStatement(); return; }

      var W = mv.clientWidth;
      // stage の文書内絶対 top（不変）基準で進捗を測る。sticky 要素自身の rect は pin 後 top 固定で測れない。
      var stageDocTop = stage.getBoundingClientRect().top + window.scrollY;
      var pinStart = STICKY_TOP - MV_MARGIN;               // mv が pin する scroll 基準
      // morph 開始 scroll 位置。ヘッダーが STICKY_TOP より低い（stageDocTop<pinStart）と負になるため 0 clamp。
      // これで scrollY=0（最上部・未スクロール）では必ず p=0＝全面 1360x600 で描画される
      // （旧実装は短ヘッダー環境で rest 時 p>0 となり初期表示が既にドック寄りに縮む不具合）。
      var start = Math.max(0, stageDocTop - pinStart);
      var scrolled = Math.max(0, window.scrollY - start);
      var p = scrolled / MORPH_PX;
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      if (p >= 1) morphDone = true;

      var baseH = W * BASE_H_RATIO;
      var dockW = W * DOCK_W;
      var dockH = dockW * DOCK_H_RATIO;
      var cardW = W - (W - dockW) * p;                     // 1360→678
      var cardH = baseH + (dockH - baseH) * p;             // 600→380
      var cardX = W * DOCK_LEFT * p;                       // 左端 x40→x722

      card.style.width = cardW + 'px';
      card.style.height = cardH + 'px';
      card.style.transform = 'translateX(' + cardX + 'px)';
      if (logo) logo.style.transform = 'scale(' + (cardW / W).toFixed(4) + ')';
      gateStatement();
    }

    function onScroll() {
      // 最終保険: 初回スクロールを起点にタイマーを張り、以後どの条件も成立しなくても必ず出す。
      // load 時ではなく初回スクロール起点にするのは、未スクロールのまま勝手に出て
      // 既存（1440）の出方が変わるのを避けるため
      if (!stTimer && !stRevealed) stTimer = setTimeout(revealStatement, GATE_FAILSAFE_MS);
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function boot() {
    var stages = document.querySelectorAll('[data-about-hero]');
    for (var i = 0; i < stages.length; i++) initStage(stages[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
